import { render } from "./externalDocumentView.vue?vue&type=template&id=275bf804&scoped=true"
import script from "./externalDocumentView.vue?vue&type=script&lang=js"
export * from "./externalDocumentView.vue?vue&type=script&lang=js"

import "./externalDocumentView.vue?vue&type=style&index=0&id=275bf804&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275bf804"]])

export default __exports__